<script>
import datePicker from 'vue-bootstrap-datetimepicker';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

import { matchCentreComment } from '../../../mixins/matchCentreComment';
import { matchCentreEditFixture } from '../../../mixins/matchCentreEditFixture';


export default {
    data() {
        return {
            date: '',
            datePickerOptions: {
                format: 'MM/DD/YYYY',
                useCurrent: true,
            },
            matchComments: null,
            disableOnSubmit: false,
            fixtures: [],
            favourites: [],
            favouriteList: null,
            message: null,
            activeDateIndex: null,
        }
    },
    watch : {
        date:function(val) {
            this.getFixtures();
            this.getUpdates();
            for (let index = 0; index < this.dates.length; index++) {
                const element = this.dates[index];
                if (element.key == this.date) {
                    this.activeDateIndex = index;
                    break;
                }
            }
            this.$forceUpdate();
        },
    },
    mixins: [matchCentreComment, matchCentreEditFixture],


    props: [
        'user', 'fixturesUrl',  'updateNameUrl', 'addCommentUrl',
        'updatesUrl', 'dates', 'today', 'favouriteListUrl',
        'muteCommentUrl', 'updateCommentUrl'
    ],
    mounted() {
        if (this.user) {
            if(this.user.first_name && this.user.last_name) {
                this.step = 3;
            } else {
                this.step = 2;
            }
            this.getFavourites();
        }

        for (let index = 0; index < this.dates.length; index++) {
            const element = this.dates[index];
            if (element.key === this.today) {
                this.activeDateIndex = index;
                break;
            }
        }
        this.date = this.today;

        //update everything every 60 seconds
        var self = this;
        setInterval(function(){
            self.getFixtures();
            self.getUpdates();
        }, 60000);
    },

    components: {
        'date-picker': datePicker,
    },

    computed: {
        activeDates: function () {
            var dates = [];
            var start = 0;
            var end = 7;

            if(this.activeDateIndex >= 3) {
                start = this.activeDateIndex - 3;
                end = this.activeDateIndex < this.dates.length - 4 ?  this.activeDateIndex + 4 : this.dates.length;
            }
            for (let index = start; index < end; index++) {
                if (index in this.dates) {
                    const element = this.dates[index];
                    element.index = index;
                    dates.push(element);
                }
            }

            return dates;
        },
    },
    methods: {
        getFixtures() {
            axios
                .get(this.fixturesUrl, {
                    params: {
                        date: this.date,
                    }
                })
                .then(response => {
                    this.sortFixtures(response.data.data);
                })
                .catch(error => {
                    console.log(error);
                });
        },
        getFavourites() {
            axios
                .get(this.favouriteListUrl, { })
                .then(response => {
                    this.favouriteList = response.data.data;
                })
                .catch(error => {
                    console.log(error);
                });

        },
        getUpdates() {
            var self = this // create a closure to access component in the callback below
            var dateFormat = this.date.split('/'); //split the date in to the correct format
            var dateDir = dateFormat[2] + '-' + dateFormat[0] + '-' + dateFormat[1];

            $.getJSON(self.updatesUrl + '/storage/match-centre/index/' + dateDir + '/updates.json', function(data) {
            })
            .done(function(data) {
                self.matchComments = data;
            })
            .fail(function(jqXHR, textStatus, errorThrown) {
                self.matchComments = [];
            });
        },

        sortFixtures(fixtures) {
            this.favourites = [];
            this.fixtures = [];
            var self = this;
            var fixtureList = [];
            var orderedFixtures = {
                'liveWithScore' : [], //CricClubs with score
                'liveNoScore' : [], //CricClubs with no score recored
                'live' : [], //Live but not on CricClubs
                'cancelled' : [],
                'scheduled' : [],
                'result' : []
            }    

            //sort fixtures into required order
            fixtures.forEach(element => {
                orderedFixtures[element.status].push(element);
            });

            //flatten fixtures into favorites at the top and other fixtures underneath
            for (const key in orderedFixtures) {
                orderedFixtures[key].forEach(element => {
                    if (element.is_favourite) {
                        self.favourites.push(element);
                    } else {
                        self.fixtures.push(element);
                    }
                });
            }

            this.$forceUpdate();
        },
        setDate(index) {
            this.date = this.dates[index].key;
        },
        incrementActiveDateIndex() {
            if(this.activeDateIndex < this.dates.length) {
                this.activeDateIndex++;
            }
            if(this.activeDateIndex < 3) {
                this.activeDateIndex = 4;
            }
        },
        decrementActiveDateIndex() {
            if(this.activeDateIndex > 0) {
                this.activeDateIndex--;
            }
        },
        forceUpdate() {
            this.disableOnSubmit = true;
            var self = this;
            axios
                .post(self.forceUpdateUrl, {} )
                .then(response => {
                    self.disableOnSubmit = false;
                    self.forceCardsToUpdate();
                })
                .catch(error => {
                    console.log(error);
                    self.disableOnSubmit = false;
                });

        },
        forceCardsToUpdate() {
            this.$refs.childRef.forEach(element => {
                element.forceUpdate();
            });
        }
    }
}
</script>
